
import Vue from "vue";

import StyleGuide from "@/components/StyleGuide.vue";

export default Vue.extend({
	name: "style-guide-page",
	components: {
		StyleGuide,
	},
	page: {
		title: "Style Guide",
		meta: [
			{
				name: "description",
				content: "This is the style guide - nobody should be able to get on non-dev environments",
			},
		],
	},
	props: {
		authenticated: Boolean,
		theme: String,
	},
	data() {
		return {};
	},
	computed: {
		inverseTheme(): string {
			return (this.theme === "dark-theme") ? "light-theme" : "dark-theme";
		}
	},
});
